import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
const tid = 'MQNLOFW5';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        props.requirePsychics();
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.psychics != this.props.psychics) {
            return true;
        }

        return false;
    }

    render({ psychics }) {
        if (psychics && Object.keys(psychics).length) {
            return (
                <keen>
                    <a
                        href='https://bargestech.go2cloud.org/aff_c?offer_id=209&aff_id=1306&url_id=41&aff_unique1=lp_api' // eslint-disable-line max-len
                        className='psychic-header'
                        target='_blank'
                        rel='noopener sponsored noreferrer'
                        onClick={() => this.props.trackEvent([
                            'Click',
                            'Psychics_LP:Header',
                        ])}
                    >
                        <row className='is-wrap is-justified-center has-padding-30-bottom'>
                            <column className='is-5 is-7-mobile'>
                                <h3>
                                    New Client Special Offer
                                    <br />
                                    Get 5 Minutes for $1.99
                                </h3>
                            </column>
                            <column className='is-3 is-5-mobile has-padding-5-left-mobile'>
                                <p className='small is-inline'>
                                    Powered by
                                </p>
                                <img
                                    className='keen-logo'
                                    src='https://gfx.tarot.com/images/site/tarot/keen/keen-logo.gif'
                                    alt='Keen Logo'
                                />
                            </column>
                        </row>
                    </a>
                    <row className='is-wrap is-justified-around'>
                        {Object.keys(psychics).map(key => this.renderPsychic(psychics[key], key))}
                    </row>
                </keen>
            );
        }

        return (<keen {...this.props} />); //eslint-disable-line tarot/no-direct-props-access-in-render
    }

    renderPsychic = (psychic, key) => {
        let psychic_url = new URL('https://bargestech.go2cloud.org/aff_c');
        psychic_url.searchParams.set('offer_id', 209);
        psychic_url.searchParams.set('aff_id', 1306);
        psychic_url.searchParams.set('aff_unique1', 'LP');

        // Manually build the inner URL to avoid double encoding
        const base_url = `https://www.keen.com${psychic.detailsUrl}`;
        const separator = base_url.includes('?') ? '&' : '?';
        const psychic_details_url = `${base_url}${separator}tid=${tid}&partnereventid={transaction_id}&tune_offerid={offer_id}`; // eslint-disable-line max-len

        psychic_url = psychic_url.toString() + '&url=' + encodeURIComponent(psychic_details_url);

        return (
            <column className='is-6 is-12-mobile has-margin-10-top-mobile'>
                <a
                    className='keen-listing-container'
                    key={key}
                    href={psychic_url}
                    target='_blank'
                    rel='noopener sponsored noreferrer'
                    onClick={() => this.props.trackEvent([
                        'Click',
                        `Psychics_LP:${key}_Card`,
                    ])}
                >
                    <div className='keen-listing-price-container'>
                        <div className='offer-text'>
                        5 minutes for $1
                        </div>
                        <div className='listing-price'>
                            {psychic.serviceRate}/min
                        </div>
                    </div>
                    <row className='is-wrap is-aligned-center has-margin-20-bottom'>
                        <column className='is-6 is-flex is-justified-center'>
                            <div className='keen-image-container'>
                                <img
                                    src={psychic.picture.size500Version
                                        ? psychic.picture.size500Version.url
                                        : psychic.pictureURL}
                                    alt={psychic.speakerName}
                                    loading='lazy'
                                    className='keen-psychic'
                                    width='165'
                                    height='165'
                                />
                                <div className='dot' />
                            </div>
                        </column>
                        <column className='is-6 has-padding-5-left has-padding-20-left-mobile
                            has-padding-5-right has-padding-15-top'
                        >
                            <p className='psychic-name'>
                                <span>{psychic.speakerName}</span>
                            </p>
                            <p className='is-h5'>
                                <span>{psychic.averageRating}</span>
                                {[0, 1, 2, 3, 4].map(() => (
                                    <img
                                        src='https://gfx.tarot.com/images/daily-pages/daily-icons/keen-star.svg'
                                        width='auto'
                                        height='auto'
                                        loading='lazy'
                                        className='star'
                                        alt='Keen Psychic Rating Stars'
                                    />
                                ))}
                            </p>
                            <p className='is-h6 has-margin-15-left has-margin-10-bottom'>
                                {psychic.ratingCount.toLocaleString()} REVIEWS
                            </p>
                            <button className='is-pill'>CHAT NOW</button>
                        </column>
                    </row>
                </a>
            </column>
        );
    }
}

const mapStateToProps = (state) => ({
    psychics: state.keen,
});

const mapDispatchToProps = (dispatch) => ({
    requirePsychics: () => dispatch({
        type: 'keen:init',
        payload: {
            tid: tid,
            size: 8,
        },
    }),
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);